import React from 'react';
import { Link } from 'lucide-react';
import { OnboardingStatusBanner } from './OnboardingStatusBanner';
import { getIntegrationsInProgress } from '../../../../utils/manualCrmConnect';

interface IntegrationsStatusBannerProps {
  organization: Parameters<typeof getIntegrationsInProgress>[0];
}

/** "{CRM} Integration Setup in Progress" while the team is still setting up the client's CRM. */
export const IntegrationsStatusBanner: React.FC<IntegrationsStatusBannerProps> = ({
  organization,
}) => {
  const crms = getIntegrationsInProgress(organization);
  if (crms.length === 0) return null;

  const crmNames = crms.join(' and ');

  return (
    <OnboardingStatusBanner
      icon={Link}
      title={`${crmNames} Integration Setup in Progress`}
      variant="green"
      iconClassName="animate-pulse"
      iconAnimation={{ animationDuration: '2s' }}
    >
      <p className="text-xs">
        Our team is currently working on setting up your {crmNames} integration. You will be
        notified once the setup is complete and review during your strategy call.
      </p>
    </OnboardingStatusBanner>
  );
};
